import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";

type Task = { name: string, isCompleted: boolean }

@Injectable({
  providedIn: 'root'
})
export class TaskStatusService {
  private tasksStatusSubject = new Subject<Map<string, boolean>>();

  tasksStatus$: Observable<Map<string, boolean>> = this.tasksStatusSubject.asObservable();

  private tasksStatus: Map<string, boolean> = new Map();

  updateTaskStatus(taskName: string, isCompleted: boolean) {
    this.tasksStatus.set(taskName, isCompleted);
    this.tasksStatusSubject.next(this.tasksStatus);
  }

  initTasks(tasks: Task[]) {
    tasks.forEach(task =>this.tasksStatus.set(task.name, task.isCompleted));
    this.tasksStatusSubject.next(this.tasksStatus);
  }
}
